module.exports = __webpack_public_path__ + "media/images/icon__point--gained@2x-e19e74214bb2f7447b914f4966e0c8e5.png";